class ComponentFruitsExplorer extends HTMLElement {
    constructor() {
        super();

        // config
        this.showArrows = this.dataset.arrows == 'true';
        this.showDots = this.dataset.dots == 'true';
        this.autoPlay = this.dataset.autoplay == 'true';
        this.autoPlayDuration = this.dataset.autoplayDuration;
        this.numSlides = this.dataset.slides;

        // internal
        this.carousel = null;
        this.buttons = this.querySelectorAll('.fruits-wrapper button');
        this.sliderWrapper = this.querySelector('.slider-wrapper .keen-slider');
        this.slides = this.sliderWrapper.children;
        
        this.initButtons();
        this.initCarousel();
    }

    initButtons() {
        var self = this;
        Array.from(this.buttons).forEach((button, b) => {
            button.addEventListener('click', e => {
                e.preventDefault();
                self.carousel.moveToSlide(b);
            })
        })
    }

    initCarousel() {    
        if (this.slides.length > 1) {
            this.carousel = new KeenSlider(this.sliderWrapper, {
                mode: "snap",
                loop: true,
                dots: this.showDots,
                prevButton: this.sliderWrapper.parentNode.parentNode.querySelector('.nav-arrow.prev'),
                nextButton: this.sliderWrapper.parentNode.parentNode.querySelector('.nav-arrow.next'),
                autoplay: this.autoPlay,
                duration: this.autoPlayDuration,
                slidesPerView: this.numSlides
            });
        } else {
            this.slidesWrapper.classList.add('initialized');
        }
        
    }
}
customElements.define('fruits-explorer', ComponentFruitsExplorer);